import { CARTLINE_QUANTITIES_COOKIE_NAME } from '@digital-retail/store-manager';
import PropTypes from 'prop-types';
import { withApplicationContext } from '../../utils/ApplicationContext';
import CookieStorage from '../../utils/CookieStorage';
import BodyCopy from '../ui/BodyCopy/BodyCopy';
import ShippingDetailsStyles from './ShippingDetails.style';

const getCurrentQty = (sku, cartCookie) => {
  const entry = cartCookie.split(',').find((item) => item.startsWith(`${sku}:`));
  return entry ? parseInt(entry.split(':')[2], 10) : 0;
};

const isNonEmptyString = (str) => {
  return typeof str === 'string' && str.trim().length > 0;
};

const ShippingDetails = ({ availabilityLabels, expressDeliveryLimit, variant }) => {
  const cartLinesCookieValue = CookieStorage.getCookie(CARTLINE_QUANTITIES_COOKIE_NAME);
  const qty = getCurrentQty(variant, cartLinesCookieValue);

  let { pickUpFromStoreShipping, homeDeliveryShipping, expressShipping } = availabilityLabels;
  if (expressDeliveryLimit > 0) {
    if (
      qty > expressDeliveryLimit &&
      (isNonEmptyString(homeDeliveryShipping) || isNonEmptyString(pickUpFromStoreShipping))
    ) {
      expressShipping = '';
    } else {
      homeDeliveryShipping = '';
      pickUpFromStoreShipping = '';
    }
  }
  return (
    <ul className="shipping-details">
      {expressShipping && (
        <li className="shipping-wrapper">
          <span className="express-icon" />
          <BodyCopy size="copy4">
            {(cl) => <span dangerouslySetInnerHTML={{ __html: expressShipping }} className={`${cl}`} />}
          </BodyCopy>
        </li>
      )}
      {homeDeliveryShipping && (
        <li className="shipping-wrapper">
          <span className="scheduled-icon" />
          <BodyCopy size="copy4">{(cl) => <span className={`${cl}`}>{homeDeliveryShipping}</span>}</BodyCopy>
        </li>
      )}
      {pickUpFromStoreShipping && (
        <li className="shipping-wrapper">
          <span className="store-icon" />
          <BodyCopy size="copy4">{(cl) => <span className={`${cl}`}>{pickUpFromStoreShipping}</span>}</BodyCopy>
        </li>
      )}
      <style jsx>{ShippingDetailsStyles}</style>
    </ul>
  );
};

ShippingDetails.propTypes = {
  availabilityLabels: PropTypes.shape({
    homeDeliveryShipping: PropTypes.string,
    pickUpFromStoreShipping: PropTypes.string,
    expressShipping: PropTypes.string,
  }),
  expressDeliveryLimit: PropTypes.number,
  variant: PropTypes.string,
};

ShippingDetails.defaultProps = {
  availabilityLabels: {},
  expressDeliveryLimit: 0,
  variant: '',
};

export { ShippingDetails };
export default withApplicationContext(ShippingDetails);
